import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InputMaskModule} from 'racoon-mask-raw';
import {HttpClientModule} from '@angular/common/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgbDateParserFormatter, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {SharedModule} from '../shared/shared.module';
import {RegistrationPageComponent} from './pages/registration-page/registration-page.component';
import {ConfirmEmailPageComponent} from './pages/confirm-email-page/confirm-email-page.component';
import {RegistrationFormComponent} from './components/registration-form/registration-form.component';
import {TermsOfUseComponent} from './components/terms-of-use/terms-of-use.component';
import {CustomDateParserFormatter} from '../shared/services/custom-date-parser-formatter';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AppRoutingModule} from '../app-routing.module';
import {NgxMaskModule} from 'ngx-mask';
import {DobMaskDirective} from './directives/dob-mask.directive';

@NgModule({
  declarations: [
    RegistrationPageComponent,
    ConfirmEmailPageComponent,
    RegistrationFormComponent,
    TermsOfUseComponent,
    DobMaskDirective
  ],
  imports: [
    CommonModule,
    SharedModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    NgbModule,
    InputMaskModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    NgxMaskModule.forRoot()
  ],
  providers: [
    {provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter}
  ]
})
export class RegistrationModule {}
